module.exports = __webpack_public_path__ + "static/img/img-separate.d8b180d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-separate.png
// module id = 448
// module chunks = 2